import { branding, Colour_Tournament } from "./Utils";

export class WinPredictor {
  constructor({
    animate,
    preview,
    update,
    animateOff,
    getVizPage,
    updateVizPage,
    vizSharedMemory,
  }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.getVizPage = getVizPage;
    this.updateVizPage = updateVizPage;
    this.vizSharedMemory = vizSharedMemory;
    this.name = "WinPredictor";
    this.scene = "WinPredictor";
    this.data = [];
    this.page = 7013;
  }

  async preview({ options }) {
    this.onAir = false;
    let xml = await this.getVizPage({ page: this.page }).catch((err) => {
      console.log(err);
    });
    if (xml) {
      xml = Colour_Tournament({ game: options.game, xml });

      xml.payload.field.find((item) => {
        return item.attr.name === "102";
      }).value = options?.title;
      xml.payload.field.find((item) => {
        return item.attr.name === "200";
      }).value = options?.stat?.home?.replace("%", "") || "";
      xml.payload.field.find((item) => {
        return item.attr.name === "201";
      }).value =
        options.game?.home_team?.variables?.alt_badge ||
        options.game?.home_team?.variables?.badge;
      let kit = options.game.home_team_kit;

      let BGColour = options?.game?.home_team.variables?.[kit + "_kit_bg_viz"];
      try {
        xml.payload.field.find((item) => {
          return item.attr.name === "202"; // home team back colour
        }).value =
          "IMAGE*__SKY_SPORTS/TEAM_ELEMENTS/RUGBY_LEAGUE/CLOCK_COLOURS/" +
          BGColour;
      } catch (err) {}

      xml.payload.field.find((item) => {
        return item.attr.name === "300";
      }).value = options?.stat?.away?.replace("%", "") || "";
      xml.payload.field.find((item) => {
        return item.attr.name === "301";
      }).value =
        options.game?.away_team?.variables?.alt_badge ||
        options.game?.away_team?.variables?.badge;

      kit = options.game.away_team_kit;

      BGColour = options?.game?.away_team.variables?.[kit + "_kit_bg_viz"];
      try {
        xml.payload.field.find((item) => {
          return item.attr.name === "302"; // home team back colour
        }).value =
          "IMAGE*__SKY_SPORTS/TEAM_ELEMENTS/RUGBY_LEAGUE/CLOCK_COLOURS/" +
          BGColour;
      } catch (err) {}

      await this.updateVizPage({ page: this.page, data: xml }).catch((err) => {
        console.log(err);
      });

      await this.sendPreview("page:read " + this.page);
    }
  }
  animate({ options }) {
    this.onAir = true;
    this.sendAnimate({ page: this.page });
  }
  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff({ page: this.page });
  }
}
